module.exports = __webpack_public_path__ + "static/media/logoBlack.eb9656c3.png";